export const DISCOUNT_PERCENTAGE = 1;
export const DISCOUNT_MONETARY = 2;

export class SaleOfferLineProduct {
  constructor(
    public hash?: string,
    public productHash?: string,
    public productName?: string,
    public productCode?: string,
    public productDescription?: string,
    public productNeedSerialNumber?: boolean,
    public productWeight?: number,
    public amount?: number,
    public discountType?: number,
    public discountNumber?: number,
    public discountAppliedAmount?: number,
    public commercialMargin?: number
  ) { }

  get isDiscountPercentage() {
    return this.discountType === DISCOUNT_PERCENTAGE;
  }

  get isDiscountMonetary() {
    return this.discountType === DISCOUNT_MONETARY;
  }

  clone() {
    return new SaleOfferLineProduct(
      this.hash,
      this.productHash,
      this.productName,
      this.productCode,
      this.productDescription,
      this.productNeedSerialNumber,
      this.productWeight,
      this.amount,
      this.discountType,
      this.discountNumber,
      this.discountAppliedAmount,
      this.commercialMargin
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-line-product.ts